export default __webpack_public_path__ + "static/media/hht2_ani_16.6d12e37f.png";